import { LOCAL_STORAGE } from "@constants/index";
import { getLocalStorage } from "@utils/local-storage";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "@configs/react-toastify/snackbar";
import { API } from "@apis/index";
import { parseDownloadFilename } from "@utils/common";

export const useUploadFileWithGit = () => {
  const { t } = useTranslation();
  const cloneRepositoryViaPta = async ({ repoInfo, requestData }) => {
    try {
      const token = getLocalStorage(LOCAL_STORAGE.TOKEN);
      const zipResponse = await API.get("/clone-via-pta", {
        responseType: "blob",
        params: {
          url: repoInfo.url?.trim(),
          token: repoInfo.token?.trim(),
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const fileName =
        parseDownloadFilename(zipResponse.headers["content-disposition"]) || "default.zip";
      const file = new File([zipResponse.data], fileName, { type: "application/x-zip-compressed" });
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      const fileList = dataTransfer.files;
      requestData.verifFile = fileList;
      requestData.repositoryImportFlag = "Y";
      return requestData;
    } catch (error) {
            let errorMessage = t("common.get-repo-failed");
            if (error.response && error.response.data instanceof Blob) {
              try {
                const responseMessage = await error.response.data.text();
                errorMessage = responseMessage || errorMessage;
              } catch (e) {
                errorMessage = t("project.verification-request.create-verification-failed");
              }
            } else if (!error.response) {
              errorMessage = t("project.verification-request.unable-to-connect-to-server");
            }
            showErrorToast(t("project.verification-request.create-verification-failed"), errorMessage);
            console.error("Clone repository failed:", error);
    }
  };

  const cloneRepositoryViaSsh = async ({ repoInfo, requestData }) => {
    try {
      const token = getLocalStorage(LOCAL_STORAGE.TOKEN);
      const zipResponse = await API.get("/clone-via-ssh", {
        responseType: "blob",
        params: { url: repoInfo.url?.trim() },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const fileName =
        parseDownloadFilename(zipResponse.headers["content-disposition"]) || "default.zip";
      const file = new File([zipResponse.data], fileName, { type: "application/x-zip-compressed" });
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      const fileList = dataTransfer.files;
      requestData.verifFile = fileList;
      requestData.repositoryImportFlag = "Y";
      return requestData;
    } catch (error) {
      let errorMessage = t("common.get-repo-failed");
      if (error.response && error.response.data instanceof Blob) {
        try {
          const responseMessage = await error.response.data.text();
          errorMessage = responseMessage || errorMessage;
        } catch (e) {
          errorMessage = t("project.verification-request.create-verification-failed");
        }
      }
      else if (!error.response) {
        errorMessage = t("project.verification-request.unable-to-connect-to-server");
      }
      showErrorToast(t("project.verification-request.create-verification-failed"), errorMessage);
      console.error("Clone repository failed:", error);
    }
  };

  return { cloneRepositoryViaPta, cloneRepositoryViaSsh };
};
